import { useEffect, MutableRefObject, useRef, useState } from 'react';
import dynamic from 'next/dynamic';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EFVideo from '@/components/UI/EFVideo';
import EFARI2 from '@/components/UI/svg/blade/treaser/EFARI2';
import { roundFloat, transformToBob } from '@/utils/common';
import { handleDynamicPath } from '@/utils/handleDynamicPath';
const Modal = dynamic(() => import('./Modal'), { ssr: true });

export default function Cut() {
    const [showModal, setShowModal] = useState(false);
    const { t } = useLang('bladeroboticlawnmower');
    const videoAutoCarRef = useRef<MutableRefObject<any>>(null);
    const [sources, setSources] = useState<string[] | null>(null);

    useEffect(() => {
        const video: any = videoAutoCarRef.current;

        AniContainer.create({
            asyncFromTo: [
                ['.cut-ani-video', { opacity: 1 }, { opacity: 1 }, 0.7],
                ['.cut-ani-01', { opacity: 0, y: 100 }, { opacity: 1, y: 0 }, 0.4],
                ['.cut-ani-01', { opacity: 1, y: 0 }, { opacity: 0, y: -100 }, 0.4],
                ['.cut-ani-02', { opacity: 0, y: 150 }, { opacity: 1, y: 0 }, 1],
                ['.cut-ani-02', { opacity: 1, y: 0 }, { opacity: 0, y: -150 }, 0.5],
                ['.cut-ani-03', { opacity: 0, y: 150 }, { opacity: 1, y: 0 }, 1],
                ['.cut-ani-03', { opacity: 1, y: 0 }, { opacity: 0, y: -150 }, 0.5],
                ['.cut-ani-04', { opacity: 0, y: 150 }, { opacity: 1, y: 0 }, 1],
                ['.cut-ani-04', { opacity: 1, y: 0 }, { opacity: 1, y: 0 }, 1],
            ],
            asyncTimeLine: [0, 0.4, 1.1, 1.5, 3, 3, 5, 5, 7],
            triggerElement: '.cut-sec-01',
            triggerHook: 0.15,
            offset: 0,
            duration: '160%',
            onProcess: (process: number) => {
                if (video) {
                    const duration: number = video?.current?.duration;
                    const currentTime = roundFloat(duration * process, 2) || 0;
                    video?.setCurrentTime(currentTime);
                }
            },
            onLazyLoad: async () => {
                try {
                    const blobUrl = await transformToBob(
                        handleDynamicPath('/video/blade/detail/pc/cut_01.mp4'),
                        handleDynamicPath('/video/blade/detail/pc/cut_01.webm'),
                    );
                    if (video) {
                        video.current.src = blobUrl;
                    }
                } catch (e) {
                    setSources(['/video/blade/detail/pc/cut_01.webm', '/video/blade/detail/pc/cut_01.mp4']);
                }
            },
            lazyHook: 4.5,
        });
    }, []);

    return (
        <>
            <div className={css['mod-cut']}>
                <div className="cut-sec-01">
                    <div id="cut" className="point"></div>
                    <div className="sticky-box">
                        <div className="video-box cut-ani-video">
                            <EFVideo ref={videoAutoCarRef} className="video" autoPlay={false} loop={false} sources={sources} />
                        </div>
                        <div className="box-center">
                            <div className="cut-ani-01">
                                <p className="cut-subtitle">{t('detail.cut_subtitle')}</p>
                                <p className="cut-title">{t('detail.cut_title')}</p>
                            </div>
                        </div>
                        <div className="box-center-y">
                            <div className="cut-content cut-ani-02">
                                <p className="cut-sec-title">{t('detail.cut_title1')}</p>
                                <p className="cut-sec-desc">{t('detail.cut_desc1')}</p>
                            </div>
                        </div>
                        <div className="box-center-y">
                            <div className="cut-content cut-ani-03">
                                <p className="cut-sec-title">{t('detail.cut_title2')}</p>
                                <p className="cut-sec-desc">{t('detail.cut_desc2')}</p>
                            </div>
                        </div>
                        <div className="box-center-y">
                            <div className="cut-content cut-ani-04">
                                <p className="cut-sec-title">{t('detail.cut_title3')}</p>
                                <p className="cut-sec-desc">{t('detail.cut_desc3')}</p>
                                <span className="btn-ar" onClick={() => setShowModal(true)}>
                                    <span className="icon">
                                        <EFARI2 />
                                    </span>
                                    {t('detail.cut_btn')}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showModal && <Modal callBack={setShowModal} />}
        </>
    );
}
